import * as Yup from 'yup';
import validation from 'modules/v2/common/validationSchema';

const validationSchema = Yup.object().shape({
  newPassword: validation.passwordCheck,
  confirmPassword: validation.confirmPassword,
});

export default validationSchema;
